import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AvailableLanguages } from '@constants';
import { TranslateUtilsService } from '@core/services/translate-utils.service';
import { CreateSupportMessageOpts, SupportChatInList } from '@interfaces';
import { TranslateService } from '@ngx-translate/core';
import { StackedMessagesService } from '@shared/stacked-messages/stacked-messages.service';
import { CommonsFacade } from '@state/commons';
import { SupportChatFacade } from '@state/support-chat';
import { ReplaySubject, take, takeUntil } from 'rxjs';

@Component({
  selector: 'app-follow-up-chat-modal',
  templateUrl: './follow-up-chat-modal.component.html',
  styleUrls: ['./follow-up-chat-modal.component.scss'],
  standalone: false,
})
export class FollowUpChatModalComponent implements OnInit {
  public readonly dialogRef = inject(MatDialogRef<FollowUpChatModalComponent>);
  private readonly supportChatFacade = inject(SupportChatFacade);
  private readonly commonsFacade = inject(CommonsFacade);
  private readonly translateUtilsService = inject(TranslateUtilsService);
  private readonly translateService = inject(TranslateService);
  private readonly stackedMessages = inject(StackedMessagesService);
  public readonly data = inject<{ supportChat: SupportChatInList }>(MAT_DIALOG_DATA);

  private destroy$: ReplaySubject<boolean> = new ReplaySubject(1);
  private followUpTextByLang: { [key: string]: string } = {};

  public languages$ = this.commonsFacade.availableLanguages$;
  public selectedLang: AvailableLanguages;

  public chatID: string;
  public dialogMessage: string;

  public async ngOnInit(): Promise<void> {
    await this.translateUtilsService.saveNamespaceTranslations('management', 'MANAGEMENT.FOLLOW_UP');
    this.chatID = this.data.supportChat.id;
    this.followUpTextByLang = this.translateUtilsService.getTranslations('FOLLOW_UP_TEXT_CHAT');
    this.selectedLang = 'en';
    this.onChangeLanguage(this.selectedLang);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onChangeLanguage(language: AvailableLanguages): void {
    this.dialogMessage = this.followUpTextByLang[language];
  }

  sendMessege(content: string): void {
    const opts: CreateSupportMessageOpts = {
      content,
      supportChatId: this.chatID,
      attachments: [],
    };

    this.supportChatFacade.createSupportMessageSuccess$.pipe(take(1), takeUntil(this.destroy$)).subscribe(() => {
      this.stackedMessages.showSuccess({
        message: this.translateService.instant('MANAGEMENT.FOLLOW_UP.FOLLOW_UP_SUCCESS', {
          username: this.data.supportChat.supportedUser.name,
        }),
        skipTranslation: true,
      });
      this.closeDialog();
    });

    this.supportChatFacade.createSupportMessage(opts);
  }
}
